import { SET_SORT } from './types';

const setSort = (payload) => ({
	type: SET_SORT,
	payload
});

export default setSort;
